/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { FormFieldType, ConditionalFieldsGroupFormField } from '../typings';
import { setConditionalParentFields } from '../store';

export class ConditionalFieldsGroupFormFieldBuilder extends BaseCompoundFormFieldBuilder<ConditionalFieldsGroupFormField> {
  protected _type = FormFieldType.ConditionalFieldsGroup;
  protected _typeValue = FormFieldType.ConditionalFieldsGroup;
  // @ts-ignore
  private _conditionField: ConditionalFieldsGroupFormField['conditionField'];
  // @ts-ignore
  private _children: ConditionalFieldsGroupFormField['children'] = [];
  // @ts-ignore
  private _isRequired: ConditionalFieldsGroupFormField['isRequired'] = false;
  // @ts-ignore
  private _groupRestrictions: ConditionalFieldsGroupFormField['groupRestrictions'];

  constructor() {
    super();
  }

  public groupRestrictions(
    value: ConditionalFieldsGroupFormField['groupRestrictions'],
  ): this {
    this._groupRestrictions = value;
    return this;
  }

  public conditionField(
    value: ConditionalFieldsGroupFormField['conditionField'],
  ): this {
    this._conditionField = value;

    const childrenIds = this._children.map(child => child.fieldId);

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  public children(value: ConditionalFieldsGroupFormField['children']): this {
    this._children = value;

    const childrenIds = this._children.map(child => child.fieldId);

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  public isRequired(
    value: ConditionalFieldsGroupFormField['isRequired'],
  ): this {
    this._isRequired = value;
    return this;
  }

  public build(): ConditionalFieldsGroupFormField {
    return {
      ...super.build(),
      type: this._type as FormFieldType.ConditionalFieldsGroup,
      typeValue: this._typeValue as FormFieldType.ConditionalFieldsGroup,
      conditionField: this._conditionField,
      children: this._children,
      isRequired: this._isRequired,
      groupRestrictions: this._groupRestrictions,
    };
  }
}
